import { useEffect } from "react";

export function useGatedCalendarScroll(selector, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    let frame = 0;
    const scroller = document.querySelector(selector);
    if (!scroller) return undefined;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const reachedTop = scroller.getBoundingClientRect().top <= 0;
        const needsInnerScroll = scroller.scrollHeight > window.innerHeight - 24;
        scroller.classList.toggle("scroll-armed", reachedTop && needsInnerScroll);
      });
    };
    update();
    window.addEventListener("scroll", update, { passive:true });
    window.addEventListener("resize", update, { passive:true });
    return () => {
      cancelAnimationFrame(frame);
      scroller.classList.remove("scroll-armed");
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [enabled, selector]);
}
